import React from "react";
import { useFormContext } from "react-hook-form";
import { LISTING_TYPES } from "repoV2/features/Listing/Listing.constants";
import { useCheckoutBasicDetailsContext } from "repoV2/features/CheckoutPages/modules/CheckoutBasicDetailsContextProvider";
import { IMultipleUsersHelpers } from "repoV2/features/Common/modules/FormData/interfaces/MultipleUserHelpers.interfaces";
import QuantitySelector from "../../../OrderBumpsFormGroup/modules/QuantitySelector/QuantitySelector";
import { multiple_user_count_key } from "../../../../../CheckoutForm/CheckoutForm.constants";
import useAddNewUserDetails from "../../utils/useAddNewUserDetails";

const AddMultipleUserCount = (props: {
    allUserIds: IMultipleUsersHelpers["allUserIds"];
}) => {
    const { allUserIds } = props;
    const { watch, setValue } = useFormContext();

    const { listingType } = useCheckoutBasicDetailsContext();

    const multipleUsersCount = watch(multiple_user_count_key);

    const { checkIsNewBatchValid } = useAddNewUserDetails();

    const handleCustomerIncrease = () => {
        // incase the listing is of type classes, we have to check if the number of users
        // is less than or equal to the allowed slots
        // incase not, we do not allow to add the user
        if (
            (listingType === LISTING_TYPES.GROUP_CLASSES ||
                listingType === LISTING_TYPES.ROLLING_CLASSES ||
                listingType === LISTING_TYPES.ONE_ON_ONE_CLASSES) &&
            !checkIsNewBatchValid({ allUserIds })
        ) {
            return;
        }
        setValue(multiple_user_count_key, multipleUsersCount + 1);
    };

    const handleCustomerDecrease = () => {
        if (multipleUsersCount > 1) {
            setValue(multiple_user_count_key, multipleUsersCount - 1);
        }
    };

    return (
        <div>
            <QuantitySelector
                currentQuantity={multipleUsersCount}
                quantityName="User"
                onIncrease={handleCustomerIncrease}
                onDecrease={handleCustomerDecrease}
            />
        </div>
    );
};

export default AddMultipleUserCount;
